







































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Detail from "@/views/operationlogs/detail.vue";

@Component({
  components: {
    Detail
  }
})
export default class extends Mixins(MyList) {
  dispatchType = "operationlogs/list";

  userInfo: { [t: string]: any } = {};

  columns: any[] = [
    { title: "操作时间", dataIndex: "created_time" },
    { title: "ip", dataIndex: "ip" },
    { title: "描述", scopedSlots: { customRender: "content" } },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.userInfo = this.$store.state.user.userInfo;
    this.loadData(
      {
        user_id: this.userInfo.id
      },
      false
    );
  }
}
